/*
 * THE FLYING BEANS — SECTION 03: THE PROCESS CONTROLLER
 * Isolated ScrollTrigger Entrance & Theme Editor Lifecycle
 * Platform: Shopify 2.0
 */

(function () {
  'use strict';

  window.TFB = window.TFB || {};

  function initProcessSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.initialized === 'true') return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      sectionEl.dataset.initialized = 'true';
      return;
    }

    var leftCol = sectionEl.querySelector('.tfb-process__left');
    var steps = sectionEl.querySelectorAll('.tfb-process__step');
    var connectors = sectionEl.querySelectorAll('.tfb-process__connector');

    if (!steps.length) return;

    var gsapUrl = sectionEl.dataset.gsapUrl;
    var stUrl = sectionEl.dataset.scrolltriggerUrl;

    function setupAnimation(gsap, ScrollTrigger) {
      sectionEl.dataset.initialized = 'true';

      // Initial states
      if (leftCol) {
        gsap.set(leftCol, { y: 30, opacity: 0 });
      }
      gsap.set(steps, { y: 35, opacity: 0 });
      if (connectors.length) {
        gsap.set(connectors, { scaleX: 0.8, opacity: 0 });
      }

      // ScrollTrigger for entrance
      ScrollTrigger.create({
        trigger: sectionEl,
        start: 'top 82%',
        once: true,
        onEnter: function () {
          var tl = gsap.timeline({ defaults: { ease: 'power2.out' } });

          if (leftCol) {
            tl.to(leftCol, { y: 0, opacity: 1, duration: 0.85 }, 0);
          }

          tl.to(steps, {
            y: 0,
            opacity: 1,
            duration: 0.8,
            stagger: 0.12,
            clearProps: 'transform,opacity'
          }, 0.2);

          if (connectors.length) {
            tl.to(connectors, {
              scaleX: 1,
              opacity: 1,
              duration: 0.6,
              stagger: 0.1,
              clearProps: 'transform,opacity'
            }, 0.35);
          }
        }
      });
    }

    if (window.gsap && window.ScrollTrigger) {
      setupAnimation(window.gsap, window.ScrollTrigger);
    } else if (typeof window.TFB.loadGSAP === 'function' && gsapUrl && stUrl) {
      window.TFB.loadGSAP(gsapUrl, stUrl)
        .then(function (ctx) {
          setupAnimation(ctx.gsap || window.gsap, ctx.ScrollTrigger || window.ScrollTrigger);
        })
        .catch(function (err) {
          console.warn('[TFB Process] GSAP load failed, falling back:', err);
          if (leftCol) leftCol.style.opacity = '1';
          steps.forEach(function (s) { s.style.opacity = '1'; });
          connectors.forEach(function (c) { c.style.opacity = '1'; });
        });
    }
  }

  function initAllProcess() {
    var sections = document.querySelectorAll('.tfb-process');
    sections.forEach(function (sec) {
      initProcessSection(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProcess);
  } else {
    initAllProcess();
  }

  // Shopify Theme Editor Integration
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.classList.contains('tfb-process-section')) {
      var sec = event.target.querySelector('.tfb-process');
      if (sec) {
        sec.dataset.initialized = 'false';
        initProcessSection(sec);
      }
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.classList.contains('tfb-process-section')) {
      if (window.ScrollTrigger) {
        var triggers = window.ScrollTrigger.getAll();
        triggers.forEach(function (st) {
          if (event.target.contains(st.trigger)) {
            st.kill(true);
          }
        });
      }
    }
  });

})();
